import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/web3-game/web3_game_banner.webp";

function Banner(props) {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 style={{ marginBottom: "10px" }}>
                Launch Immersive Games with TekRevol’s {}
                <span style={{ color: "#F47a14" }}>Web3 Game</span> Development
                Services
              </h1>
              <p style={{ marginTop: "10px" }}>
                TekRevol combines talent and tech to help game entrepreneurs and
                media startups build and launch revenue-ready Web3 games 3X
                faster with 2X efficiency. As a Web3 game development company
                that’s driven by agility and innovation, we support
                technopreneurs in bringing their most amazing and captivating
                game concepts to decentralized reality – and with exceptional
                graphics, high-fidelity, chart-busting ROI, and unbeatable
                growth! 
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect
              </Link>
              <button
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
